import React from 'react';
import { ContactList } from '../components/contacts/ContactList';

export function ContactsPage() {
  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-header-title">Kontakte</div>
          <div className="page-header-sub">Alle Ansprechpartner über alle Firmen</div>
        </div>
      </div>
      <div className="content">
        <ContactList />
      </div>
    </>
  );
}
